import React from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { connect, ConnectedProps } from "react-redux"
import { RootState } from "../../store/store"
import { appointment } from "../../store/actions/types"
import { setAppointment } from "../../store/actions"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { helpBlueIcon, refreshIcon, info } from "../../images"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { Modal } from "@fourkites/elemental-modal"
import "../DriverForm/driverForm.css"
import "./referenceForm.css"
import i18next from "i18next"

const mapStateToProps = (state: RootState) => ({
  facility: state.facilityReducer.facility,
  driver: state.driverReducer.driver,
  visit: state.visitReducer.visit,
  appointment: state.appointmentReducer.appointment
})

const mapDispatchToProps = {
  setAppointment: (appointment: appointment) => setAppointment(appointment)
}

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & RouteComponentProps

interface State {
  reference: string
  invalidReference: boolean
  disabledProceed: boolean
  routeTo: string
  resumeSession: boolean
  showModal: boolean
}

class ReferenceForm extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      reference: "",
      invalidReference: false,
      disabledProceed: true,
      routeTo: "",
      resumeSession: false,
      showModal: false
    }
  }

  setReference = (event: any) => {
    let reference: string = event.target.value
    if (
      reference.includes("<") ||
      reference.includes(">") ||
      reference.length > 20
    ) {
      return
    }
    this.setState({
      reference: reference,
      disabledProceed: reference.length === 0
    })
  }

  fetchAppointment = () => {
    let invalidReference: boolean = this.state.reference.trim().length === 0
    if (invalidReference) {
      this.setState({
        invalidReference: invalidReference,
        disabledProceed: true
      })
      return
    }
    http
      .post(
        `${apiEndPoints.fetchAppointment}`,
        {
          visitId: this.props.visit.id,
          identifierType: "any",
          identifierValue: this.state.reference.trim()
        },
        {}
      )
      .then(response => {
        const { data } = response.data
        this.props.setAppointment({
          type: data?.type,
          details: data?.appointmentDetails,
          matchingVisitDetails: data?.matchingVisitDetails,
          smsMatchingVisitDetails: data?.matchingVisitDetails,
          isNewSession: false
        })
        if (
          data.matchingVisitDetails &&
          Object.values(data.matchingVisitDetails).length > 0
        ) {
          if (data.matchingVisitDetails.status == "check-out") {
            this.props.history.push("/visitsummary")
            return
          }
          this.setState({
            resumeSession: true
          })
        } else {
          this.setState({
            resumeSession: false
          })
          this.props.history.push(this.state.routeTo)
        }
      })
      .catch(() => {
        this.setState({
          invalidReference: true,
          disabledProceed: true
        })
      })
  }

  onShowModal = () => {
    this.setState({ showModal: true })
  }

  onConfirmModal = () => {
    this.setState({ showModal: false })
    this.props.setAppointment({
      type: this.props.appointment.type,
      details: this.props.appointment.details,
      smsMatchingVisitDetails: this.props.appointment.matchingVisitDetails,
      matchingVisitDetails: { id: "", status: "" },
      isNewSession: true
    })
    this.props.history.push(this.state.routeTo)
  }

  onResume = () => {
    http
      .post(
        `${apiEndPoints.activities}${this.props.visit.id}/activities`,
        {
          type: "resume",
          details: {
            reVisitId: this.props.appointment?.matchingVisitDetails?.id
          }
        },
        {}
      )
      .then(() => {
        const status = this.props.appointment?.matchingVisitDetails?.status
        const { facility } = this.props.visit?.visit
        const modules = facility?.configuration?.modules
        const edocsAvailable = modules.filter(
          (module: any) => module.name === "edocs"
        )
        if (status === "check-in" && edocsAvailable && edocsAvailable.length) {
          this.props.history.push({
            pathname: "edocs",
            state: { data: "referenceNumber", status: status }
          })
        } else if (status === "appointment-details-sent") {
          this.props.history.push({
            pathname: this.state.routeTo.substring(
              1,
              this.state.routeTo.length
            ),
            state: { data: "referenceNumber", status: status }
          })
        } else {
          this.props.history.push({
            pathname: "edocs",
            state: { data: "referenceNumber", status: status }
          })
        }
      })
  }

  componentDidMount() {
    const { facility } = this.props.visit?.visit
    const modules = facility?.configuration?.modules
    const edocsAvailable = modules.filter(
      (module: any) => module.name === "edocs"
    )
    const checkinAvailable = modules.filter(
      (module: any) => module.name === "gate"
    )
    if (edocsAvailable.length && !checkinAvailable.length) {
      this.setState({ routeTo: "/edocs" })
    } else {
      this.setState({ routeTo: "/check-in" })
    }
  }
  trans = (key: string) => {
    return i18next.t(key) || ""
  }
  render() {
    return (
      <>
        <div className="container">
          <div className="reference-info">
            <div className="welcome">
              Hi{" "}
              <span style={{ textTransform: "capitalize" }}>
                {this.props.driver.name}
              </span>
              ! {"\u{1F44B}"}
            </div>
            <div className="info">
              {i18next.t("welcome_to")} &nbsp;
              <b>
                <span style={{ textTransform: "capitalize" }}>
                  {this.props.facility.name}
                </span>
              </b>
              &nbsp;{i18next.t("facility")}
            </div>
          </div>
          <div
            className={`reference-input ${
              this.state.invalidReference ? "error-label" : ""
            }`}
          >
            <Input
              label={this.trans("reference_number")}
              value={this.state.reference}
              placeholder={this.trans("enter_load_or_reference_number")}
              required={true}
              onClick={() => this.setState({ invalidReference: false })}
              onChange={event => this.setReference(event)}
              invalid={this.state.invalidReference}
              errorLabel={
                this.state.invalidReference
                  ? this.trans("invalid_reference_number")
                  : ""
              }
              icon={this.state.invalidReference ? <AlertIcon /> : <></>}
              disabled={this.state.resumeSession}
            />
          </div>
          <div className="info">{i18next.t("enter_load_number")}</div>
          {!this.state.resumeSession && (
            <div
              className="no-ref-help"
              onClick={() => {
                this.props.history.push({
                  pathname: "support",
                  state: { data: "referenceNumber" }
                })
              }}
            >
              <img src={helpBlueIcon} alt="help" className="vert-middle" />
              <span className="no-ref-help-text">
                {i18next.t("not_having_reference_number")}
              </span>
            </div>
          )}
          {this.state.resumeSession && (
            <div className="no-ref-help" onClick={this.onShowModal}>
              <img src={refreshIcon} alt="help" className="vert-middle" />
              <span className="no-ref-help-text">
                {i18next.t("start_new_session")}
              </span>
            </div>
          )}
          {this.state.resumeSession && (
            <div className="warning-info">
              <img className="warning-info-img" src={info} alt="info" />
              <div className="warning-info-text">
                {i18next.t("tap_on_above_link")}
              </div>
            </div>
          )}
        </div>
        <BottomBar
          disabled={this.state.disabledProceed}
          onClick={
            this.state.resumeSession
              ? () => this.onResume()
              : this.fetchAppointment
          }
          text={
            this.state.resumeSession
              ? i18next.t("resume")
              : i18next.t("proceed")
          }
          endIcon={<KeyboardArrowRightIcon />}
        />
        <Modal
          title=""
          customHeader={
            <div className="header-container">
              <span>
                <AlertIcon className="alert-icon" />
                {i18next.t("start_new_session_question_mark")}
              </span>
              <span
                className="close-icon"
                onClick={() => this.setState({ showModal: false })}
              >
                X
              </span>
            </div>
          }
          show={this.state.showModal}
          size="large"
          onClose={() => this.setState({ showModal: false })}
          onSave={() => this.onConfirmModal()}
          saveLabel={i18next.t("confirm") || ""}
          closeLabel={i18next.t("cancel") || ""}
        >
          <div className="modal-container">
            <p>{i18next.t("confirm_new_session")}</p>
            <p>{i18next.t("new_session_clearing_data_warning")}</p>
          </div>
        </Modal>
      </>
    )
  }
}

export default withRouter(connector(ReferenceForm))
